var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSponsorApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7214 2.16613V13.6888H23.6965V19.4255H20.7214L20.7029 25.8215L10.7734 25.8461C12.184 24.1824 13.9149 21.7115 15.153 18.4088C16.2309 15.5435 16.5081 13.1835 16.7483 11.0022C16.9947 8.77779 17.1487 5.75233 16.7607 2.15381C18.0788 2.15997 19.4032 2.16613 20.7214 2.16613Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9207 2.15381C12.5026 7.72141 9.80978 12.4551 4.81762 14.6569C4.65162 16.2348 4.47947 17.8067 4.31348 19.3846C5.86892 18.8746 10.2893 17.2127 13.6338 12.707C16.9169 8.28537 17.2058 3.76169 17.2366 2.15381H12.9207Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.98014 6.15932C8.98014 7.44624 7.93687 8.49577 6.6437 8.49577C5.35054 8.49577 4.31348 7.45249 4.31348 6.15932C4.31348 4.87239 5.35678 3.8291 6.6437 3.8291C7.93062 3.8291 8.98014 4.87239 8.98014 6.15932Z",
    fill: "#0082CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorApp);
export default __webpack_public_path__ + "static/media/sponsor-app.d1e3e2366be0222bc29de94b4dae8541.svg";
export { ForwardRef as ReactComponent };